const getRedemptionsColumns = () => {
  return [
    {
      title: 'S.No',
      dataIndex: 'id',
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,

      width: '10%'
    },
    {
      title: 'Name',
      dataIndex: 'nameOfSubscriber',
      width: '25%'
    },
    {
      title: 'Inv Id',
      dataIndex: 'seqNo',
      width: '25%'
    },
    {
      title: 'ShareClass',
      dataIndex: 'shareClassType',
      width: '25%'
    },

    {
      title: 'Redemption Amount',
      dataIndex: 'redemptionAmount',
      width: '25%'
    },
    {
      title: 'Redemption Status',
      dataIndex: 'redemptionStatus',
      width: '25%'
    },
    
  ]
}

export default getRedemptionsColumns
